module.exports = __webpack_public_path__ + "b38edf826cf9852fcb263a9adab71481.pdf";